import Grid from '@mui/material/Grid'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Step } from 'react-joyride'
import { Card } from 'ui/atoms'
import ModuleHeader from 'ui/components/ModuleHeader/ModuleHeader'
import Tour from 'ui/components/Tour/Tour'
import View from 'ui/components/View/View'

import ShiftInfoWidget from 'views/ShiftScheduleView/components/ShiftInfoWidget/ShiftInfoWidget'

const widgetConstants = {
  HANDOVER_GRID: `shiftSchedule`,
  HANDOVER_WIDGET_1: `item-1`,
  HANDOVER_WIDGET_2: `item-2`,
}

const calendar: Array<Step> = [
  {
    target: widgetConstants.HANDOVER_WIDGET_1,
    content: `Here you can see the current shift schedule on a weekly basis. Each shift team has its own colour in the schedule. It is also possible to view the shift schedule several weeks ahead or back by pressing the arrows above the schedule.`,
    title: `Shift information`,
  },
]

export default function ShiftScheduleView(): ReactElement {
  const { t } = useTranslation()
  const [runTour, setRunTour] = useState<null | number>(null)

  return (
    <View
      header={
        <ModuleHeader
          infoHeader={t(`Shift Schedule`)}
          onInfoButtonClick={() => {
            setRunTour(0)
          }}
        />
      }
    >
      <Tour
        isSingle={!!runTour}
        run={runTour !== null}
        setRunState={(state: boolean) => setRunTour(state ? 0 : null)}
        steps={calendar}
      />
      <Grid size={12}>
        <Card tourId={widgetConstants.HANDOVER_WIDGET_1} title={t(`Schedule`)}>
          <ShiftInfoWidget />
        </Card>
      </Grid>
    </View>
  )
}
